// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__35Gkl","content":"GlobalSearch_content__2v1eN"};